import 'jquery.cookie';

import wildcardDomain from '@/js/common/Domain/Service/wildcardDomain';
import requestService from './request';

export default (tourCriteriaForTourRequest, callback) => {
    const options = {
        cache: false,
        data: tourCriteriaForTourRequest,
        type: 'POST',
        url: `${window.appConfig.apiGatewayUrl}/frontend/hotelOffers/asyncSearch`,
    };

    return requestService(options, callback);
};